<template>
  <div class="page-box">
    <!-- 头部标题 +++++++++++++++++++++++++++++++++++++++++ -->
    <div class="dtl-head">
      <div class="pageTit c-breadcrumb">
        <el-breadcrumb separator=">" class="theme-default">
          <el-breadcrumb-item :to="{ path: '/financingFundlist' }"> {{ $t('financingFundDetail.nav1') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('financingFundDetail.tittle') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--流水号-->
      <p class="top-tit" style="text-align:right;padding-right:90px;width:unset"><span>{{ $t('loan.financingNum') }}：</span>
        <span>{{ flowNumber }}</span>
      </p>
      <!-- 分割图片 -->
      <img class="c-divider" src="../../assets/images/common/documentSeparation.png" alt="">
    </div>

    <div class="bonusDetail" style="margin-top: -5px;">
      <div class="bgW boxRadius boxShadow" style="min-height: 260px;margin-bottom: 20px;">

        <el-tabs type="border-card" class="theme-default" style="border-radius: 4px;">
          <!--申请基本信息Tab-->
          <!--融资合同-->
          <el-tab-pane v-if="!((applicationStatus===8 || applicationStatus===9) && !cicFinancingCostDraftSnapshot)" :label="$t('financingFundDetail.tab3')" class="con1020">
            <!-- CIC费用-->
            <cicFee v-if="cicFinancingCostDraftSnapshot" :data="cicFinancingCostDraftSnapshot"/>
            <!--融资信息-->
            <div>
              <el-form v-if="isShowFooter&&applicationStatus===10" ref="ruleForm" :model="formObj" :rules="rules" label-position="left" label-width="130px" class="demo-ruleForm">
                <div v-if="isShowFooter&&applicationStatus===10" class="nyTit" style="margin-bottom: 20px"><i/>{{ $t('loan.financingInfo') }}</div>
                <!--                  融资金额-->
                <el-form-item :label="$t('loan.financingmount')" prop="financingMoney">
                  <el-input v-model.trim="formObj.financingMoney" :placeholder="$t('financingFundList.enterPlaceHolder')" class="theme-default w520" maxlength="50" @blur="financingMoneyBlur">
                    <el-select slot="prepend" v-model="formObj.financingCurrency" :placeholder="$t('frontPage.pleaseChoose')" no-data-text="" popper-class="selectClass" style="width: 88px;background:none;">
                      <el-option v-for="(key,value) in moneyType" :label="value" :value="key" :key="key"/>
                    </el-select>
                  </el-input>
                </el-form-item>
                <!--                  利率-->
                <el-form-item :label="$t('loan.interestRate')" prop="interestRate">
                  <el-input v-model.trim="formObj.interestRate" :placeholder="$t('financingFundList.enterPlaceHolder')" class="theme-default w520" popper-class="selectClass" maxlength="50" @blur="interestRateBlur">
                    <template slot="append" style="width: 90px;border:0"><span>%</span></template>
                  </el-input>
                </el-form-item>
                <!--                  利息-->
                <el-form-item :label="$t('loan.interest')" prop="interest">
                  <el-input v-model.trim="formObj.interest" :placeholder="$t('financingFundList.enterPlaceHolder')" class="theme-default w520" maxlength="50" @blur="interestBlur">
                    <el-select slot="prepend" v-model="formObj.interestCurrency" :placeholder="$t('frontPage.pleaseChoose')" no-data-text="" popper-class="selectClass" style="width: 88px;background:none;">
                      <el-option v-for="(key,value) in moneyType" :label="value" :value="key" :key="key"/>
                    </el-select>
                  </el-input>
                </el-form-item>
                <!--                  总费用-->
                <el-form-item :label="$t('loan.totalCost')" >
                  US$ {{ totalFee | formatNum }}
                </el-form-item>
                <!--                  发放币种-->
                <el-form-item :label="$t('loan.issueCurrency')" prop="grantCurrency">
                  <el-select v-model="formObj.grantCurrency" :placeholder="$t('frontPage.pleaseChoose')" no-data-text="" >
                    <el-option v-for="(key,value) in moneyType" :label="value" :value="key" :key="key"/>
                  </el-select>
                </el-form-item>
                <!--                  还款币种-->
                <el-form-item :label="$t('loan.paymentCurrency')" prop="repaymentCurrency">
                  <el-select v-model="formObj.repaymentCurrency" :placeholder="$t('frontPage.pleaseChoose')" no-data-text="" >
                    <el-option v-for="(key,value) in moneyType" :label="value" :value="key" :key="key"/>
                  </el-select>
                </el-form-item>
                <!--                  汇率-->
                <el-form-item :label="$t('loan.exchangeRate')" prop="exchangeRate">
                  <el-input v-model.trim="formObj.exchangeRate" :placeholder="$t('financingFundList.enterPlaceHolder')" class="theme-default w520" maxlength="50"/>
                </el-form-item>

                <div v-if="isShowFooter&&applicationStatus===10" class="nyTit" style="margin-bottom: 20px"><i/>{{ $t('loan.fundFlowData') }}</div>
                <!--                  预计开始日期-->
                <el-form-item :label="$t('loan.expectStartDate')" prop="estimateStartDate">
                  <el-date-picker
                    v-model="formObj.estimateStartDate"
                    :placeholder="$t('financingFundList.enterPlaceHolder')"
                    type="date"
                    class="theme-default w520"
                  />
                </el-form-item>
                <!--                  预计到期日期-->
                <el-form-item :label="$t('loan.expectDueDate')" prop="estimateEndDate">
                  <el-date-picker
                    v-model="formObj.estimateEndDate"
                    :placeholder="$t('financingFundList.enterPlaceHolder')"
                    type="date"
                    class="theme-default w520"
                  />
                </el-form-item>
                <!--                  天数-->
                <el-form-item :label="$t('loan.numberOfDay')">
                  {{ day }} {{ $t('frontPage.day') }}
                </el-form-item>

                <!--                  资金锁定-->
                <div class="nyTit" style="margin-bottom: 20px"><i/>{{ $t('financingFundDetail.Tit9') }}</div>
                <!--                  资金锁定-->
                <el-form-item :label="$t('financingFundDetail.Tit9')" prop="lockedMoney">
                  <el-input v-show="applicationStatus===10" v-model.trim="formObj.lockedMoney" :placeholder="$t('financingFundDetail.lockPopTit1')+ zmaFinancingManagement.availableBalance" class="theme-default w520" maxlength="50" @blur="lockedMoneyBlur">
                    <template slot="prepend"><span style="color: #333333;">US$</span></template>
                  </el-input>
                </el-form-item>
              </el-form>
              <div v-if="applicationStatus!==10 && zmaFinancingInfo" class="nyTit"><i/>{{ $t('loan.financingInfo') }}</div>
              <financingInfo v-if="applicationStatus!==10 && zmaFinancingInfo" ref="zmaFinancingInfo" :status="applicationStatus" :data="zmaFinancingInfo" @update="getDetail"/>
              <!--                  融资信息-->
              <table v-if="applicationStatus!==10" border="0" cellpadding="0" cellspacing="0" class="tableCol2" style="width: 1020px;">
                <tr v-if="zmaFinancingInfo.lockedMoney || zmaFinancingInfo.lockedMoney==0">
                  <td class="td1" colspan="2">
                    <div class="nyTit" style="margin-bottom: 10px;"><i/>
                      <!--            资金锁定-->
                      {{ $t('financingFundDetail.Tit9') }}
                    </div>
                  </td>
                  <!--        <td class="td2"></td>-->
                </tr>
                <tr v-if="zmaFinancingInfo.lockedMoney || zmaFinancingInfo.lockedMoney==0">
                  <td class="td1">
                    <!--          资金锁定额-->
                    {{ $t('financingFundDetail.lockMoneyTip') }}
                  </td>
                  <td class="td2">{{ zmaFinancingInfo.lockedCurrency }} {{ zmaFinancingInfo.lockedMoney | formatNum }} </td>
                </tr>
                <!--      <tr>-->
                <!--        <td class="td1"></td>-->
                <!--        <td class="td2"></td>-->
                <!--      </tr>-->
              </table>
              <!--            资金锁定-->
            </div>
            <!--                资金出入日期-->
            <!--                <time-of-capital-flow :data="timeList"></time-of-capital-flow>-->

            <!--评级-->
            <rankInfo v-if="zmaFinancingManagement" :data="zmaFinancingManagement" :cic-financing-apply-draft-snapshot="cicFinancingApplyDraftSnapshot" />
            <!-- 风控审核记录-->
            <auditLogInfoList v-if="riskManagementList && riskManagementList.length>0" :data="riskManagementList"/>
            <!-- 资金锁定审核记录-->
            <div v-if="lockManagementList&& lockManagementList.length>0">
              <div class="nyTit"><i/> {{ $t('loan.fundLockAuditRecord') }}</div>
              <fundLockAuditRecord v-if="lockManagementList" :data="lockManagementList"/>
            </div>
          </el-tab-pane>
          <!--申请附加信息tab-->
          <!-- 申请基本信息-->
          <el-tab-pane :label="$t('loan.applyBasicInfo')" class="con1020">
            <!--贸易信息-->
            <div class="nyTit"><i/>{{ $t('loan.tradeInfo') }}</div>
            <baseTradeInfo v-if="cicFinancingApplyDraftSnapshot" :data="cicFinancingApplyDraftSnapshot"/>
            <!--  融资基础信息-->
            <div class="nyTit"><i/>{{ $t('loan.financingBasicInfo') }}</div>
            <financingBaseInfo v-if="cicFinancingApplyDraftSnapshot" :data="cicFinancingApplyDraftSnapshot"/>

            <base-info-finance ref="baseDataFinance"/>
            <!--  当前融资情况 + 最近10笔融资申请 + 最近10笔订单 -->

            <div v-if="(applicationStatus===8 || applicationStatus===9)&& !cicFinancingCostDraftSnapshot">
              <!--评级-->
              <rankInfo v-if="zmaFinancingManagement" :data="zmaFinancingManagement" :cic-financing-apply-draft-snapshot="cicFinancingApplyDraftSnapshot" />
              <!-- 风控审核记录-->
              <auditLogInfoList v-if="riskManagementList && riskManagementList.length>0" :data="riskManagementList"/>
            </div>

          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="height: 110px;"/>
      <div v-if="isShowFooter&&applicationStatus===10" class="text-center whiteFixed">
        <!--            <div class="centerBtn btn-blue" @click="back">-->
        <!--              &lt;!&ndash;返回&ndash;&gt;-->
        <!--              {{$t('btns.back')}}-->
        <!--            </div>-->
        <div class="centerBtn btn-blue" @click="isShow = true">
          <!--             打回-->
          {{ $t('btns.repulse') }}
        </div>
        <div class="centerBtn btn-blue" @click="submitForm('ruleForm')">
          <!--             提交-->
          {{ $t('btns.submit') }}
        </div>
      </div>
      <!-- 一审-->
      <div v-if="isShowFooter&&applicationStatus===11" class="text-center whiteFixed">
        <!--            <div class="centerBtn btn-blue" @click="back">-->
        <!--              &lt;!&ndash;返回&ndash;&gt;-->
        <!--              {{$t('btns.back')}}-->
        <!--            </div>-->
        <div class="centerBtn btn-blue" @click="isShow = true">
          <!--              打回-->
          {{ $t('btns.repulse') }}
        </div>
        <div class="centerBtn btn-blue" @click="openTqTipPop">
          <!--              通过-->
          {{ $t('btns.pass') }}

        </div>
      </div>
      <!-- 二审-->
      <div v-if="isShowFooter&&applicationStatus===12" class="text-center whiteFixed">
        <div class="centerBtn btn-blue" @click="isShow = true">
          <!--              打回-->
          {{ $t('btns.repulse') }}
        </div>
        <div class="centerBtn btn-blue" @click="isShowClose=true">
          <!--              拒绝-->
          {{ $t('btns.refuse') }}
        </div>
        <div class="centerBtn btn-blue" @click="openTqTipPop">
          <!--              通过-->
          {{ $t('btns.pass') }}
        </div>
      </div>
    </div>

    <!--打回弹框 begin-->
    <VerifyPopup v-if="isShow" :title="$t('fancingFundDetail.sureBack')" :placeholder="$t('financingFundDetail.verifyPopupPlaceholder')" maxlength="300" @cancel="hide" @confirm="submitRepulse"/>
    <!--打回弹框 end-->

    <!--拒绝弹框 begin-->
    <VerifyPopup v-if="isShowClose" :title="$t('fancingFundDetail.sureReject')" :placeholder="$t('financingFundDetail.verifyPopupPlaceholder')" maxlength="300" @cancel="hide" @confirm="submitClose"/>
    <!--拒绝弹框 end-->
    <!--通过锁定资金-->
    <el-dialog
      :title="$t('financingFundDetail.lockPopTit')"
      :visible.sync="tqTipPopVisible"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="tipPop"
      @closed="closeTqTipPop">
      <i class="tipsIco" style=""/>
      <ul class="listDetail" style="width: 390px; padding-top:42px;">
        <li class="clearfix">
          <div class="item itemL">
            <!--当前资金池可用余额-->
            {{ $t('financingFundDetail.lockPopTit1') }}：
          </div>
          <div class="item itemR"><span class="red">US$ {{ zmaFinancingManagement.availableBalance | formatNum }}</span> </div>
        </li>
        <li class="clearfix">
          <div class="item itemL">
            <!--本次将锁定-->
            {{ $t('financingFundDetail.lockPopTit2') }}:
          </div>
          <div class="item itemR"><span class="red">US$ {{ formObj.lockedMoney | formatNum }} </span></div>
        </li>
        <li class="clearfix">
          <div class="item itemL">
            <!--锁定后余额-->
            {{ $t('financingFundDetail.lockPopTit3') }}：
          </div>
          <div class="item itemR"><span class="red">US$ {{ finalMoney | formatNum }} </span></div>
        </li>
      </ul>

      <div slot="footer" class="dialog-footer text-center">
        <div class="centerBtn btn-border-normal" @click="tqTipPopVisible = false">
          <!--取消-->
          {{ $t('btns.cancel') }}
        </div>
        <div class="centerBtn btn-blue" @click="validPass">
          <!--确定-->
          {{ $t('btns.confirm') }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VerifyPopup from '../../components/VerifyPopup'
import auditLogInfoList from '../../components/financingComponents/auditLogInfoList'
import cicFee from '../../components/financingComponents/cicFee'
import financingInfo from '../../components/financingComponents/financingInfo'
import rankInfo from '../../components/financingComponents/rankInfo'
import fundLockAuditRecord from '../../components/financingComponents/fundLockAuditRecord'
import baseTradeInfo from '../../components/financingComponents/baseTradeInfo'
import financingBaseInfo from '../../components/financingComponents/financingBaseInfo'
import baseInfoFinance from '@/components/pageDtl/baseInfoFinance'
import mixins from '@/helper/mixins.js'
import { mapState } from 'vuex'
const math = require('mathjs')
export default {
  name: 'FinancingFundDetail',
  mixins: [mixins],
  data() {
    var validateFinancingMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('financing.pleaseWrite')))
      } else {
        if (!this.$utils.isMoney(this.formObj.financingMoney)) {
          this.formObj.financingMoney = ''
          // 最多只能有两位小数
          callback(new Error(this.$t('financingFundDetail.validMoney')))
        }
        callback()
      }
    }
    var validateInterest = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('financing.pleaseWrite')))
      } else {
        if (!this.$utils.isMoney(this.formObj.interest)) {
          this.formObj.interest = ''
          callback(new Error(this.$t('financingFundDetail.validMoney')))
        }
        callback()
      }
    }
    var validateInterestRate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('financing.pleaseWrite')))
      } else {
        if (!this.$utils.isInterRest(this.formObj.interestRate)) {
          this.formObj.interestRate = ''
          callback(new Error(this.$t('financingFundDetail.validateInterestRate')))
        }
        callback()
      }
    }
    var validateLockedMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('financing.pleaseWrite')))
      } else {
        if (!this.$utils.isMoney(this.formObj.lockedMoney)) {
          this.formObj.lockedMoney = ''
          callback(new Error(this.$t('financingFundDetail.validMoney')))
        }
        callback()
      }
    }
    return {
      ifIsSuper: '',
      menuType: '',
      applicationStatus: '',
      flowNumber: this.$route.query.in_id,
      moneyType: '',
      finalMoney: '',
      rules: {
        estimateStartDate: [{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'blur' }],
        estimateEndDate: [{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'blur' }],
        financingMoney: [{ required: true, validator: validateFinancingMoney, trigger: 'blur' }],
        interestRate: [{ required: true, validator: validateInterestRate, trigger: 'blur' }],
        interest: [{ required: true, validator: validateInterest, trigger: 'blur' }],
        grantCurrency: [{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'change' }],
        repaymentCurrency: [{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'change' }],
        exchangeRate: [{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'blur' }],
        lockedMoney: [{ required: true, validator: validateLockedMoney, trigger: 'blur' }]
      },
      isShowFooter: false,
      submited: false, // 防止重复提交
      isShowPass: false, // 通过审核弹框
      isShow: false, // 打回审核弹框
      isShowClose: false, // 拒绝弹框开关
      tqTipPopVisible: false, // 资金锁定提取弹窗开关
      isView: false, // 是否是查看页面
      hasPermission: false,
      riskManagementList: '',
      lockManagementList: '',
      cicFinancingCostDraftSnapshot: '',
      zmaFinancingInfo: '',
      cicFinancingApplyDraftSnapshot: '',
      zmaFinancingManagement: '',
      formObj: {
        flowNumber: this.$route.query.in_id,
        estimateStartDate: '',
        estimateEndDate: '',
        financingMoney: '',
        financingCurrency: '',
        interestRate: '',
        interest: '',
        interestCurrency: '',
        grantCurrency: '',
        repaymentCurrency: '',
        exchangeRate: '',
        lockedMoney: ''
      }, // 资金锁定提交入参
      adoptParameter: {
        flowNumber: this.$route.query.in_id
      }, // 通过入参
      repulseParameter: {
        flowNumber: this.$route.query.in_id,
        repulseReason: ''
      }, // 打回入参
      closeParameter: {
        flowNumber: this.$route.query.in_id,
        closeReason: ''
      }, // 拒绝入参
      timeList: [] // 资金出入日期列表数据
    }
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName // 登录用户名
    },
    day() {
      if (this.$utils.isObjFn(this.formObj)) {
        const estimateStartDate = this.formObj.estimateStartDate
        const estimateEndDate = this.formObj.estimateEndDate
        if (estimateStartDate && estimateEndDate) {
          const startDateTime = estimateStartDate.getTime()
          const endDateTime = estimateEndDate.getTime()
          if (estimateEndDate >= estimateStartDate) {
            return (endDateTime - startDateTime) / (1000 * 3600 * 24)
          }
        } else {
          return 0
        }
      }
    },
    totalFee() {
      const cicFinancingCostDraftSnapshot = this.cicFinancingCostDraftSnapshot
      const interest = this.formObj.interest
      if ((cicFinancingCostDraftSnapshot && this.$utils.isObjFn(cicFinancingCostDraftSnapshot)) || interest) {
        if (interest && this.$utils.isMoney(interest)) {
          // return cicFinancingCostDraftSnapshot.serviceCharge+cicFinancingCostDraftSnapshot.agencyFee+cicFinancingCostDraftSnapshot.insurancePremium+interest
          return math.number(math.add(math.bignumber(cicFinancingCostDraftSnapshot.serviceCharge), math.bignumber(cicFinancingCostDraftSnapshot.agencyFee), math.bignumber(cicFinancingCostDraftSnapshot.insurancePremium), math.bignumber(interest)))
        } else {
          // return cicFinancingCostDraftSnapshot.serviceCharge+cicFinancingCostDraftSnapshot.agencyFee+cicFinancingCostDraftSnapshot.insurancePremium
          return math.number(math.add(math.bignumber(cicFinancingCostDraftSnapshot.serviceCharge), math.bignumber(cicFinancingCostDraftSnapshot.agencyFee), math.bignumber(cicFinancingCostDraftSnapshot.insurancePremium)))
        }
      } else {
        return 0
      }
    }
  },
  components: {
    VerifyPopup,
    auditLogInfoList,
    cicFee,
    financingInfo,
    rankInfo,
    fundLockAuditRecord,
    baseTradeInfo,
    financingBaseInfo,
    baseInfoFinance
  },

  mounted() {
    this.$nextTick(function() {
      document.title = this.$t('financingFundDetail.tittle')
      const menuType = Number(this.$route.query.menuType)
      if (menuType) {
        this.menuType = menuType
      }
      this.getDetail()
      this.isSuper()
      const ifIsSuper = this.ifIsSuper
      if (ifIsSuper === 1) {
        this.isShowFooter = true
      } else {
        this.getBtnLimit(this.flowNumber).then(data => {
          console.log('type', data.type)
          if (data.type) {
            this.isShowFooter = true
          } else {
            this.isShowFooter = false
          }
        }) // 获取系统按钮权限
      }
      this.getdiscList()
    })
  },
  methods: {

    interestRateBlur: function() {
      this.formObj.interestRate = this.$utils.convertNum(this.formObj.interestRate, 2)
    },
    financingMoneyBlur: function() {
      this.formObj.financingMoney = this.$utils.convertNum(this.formObj.financingMoney, 4)
    },
    interestBlur: function() {
      this.formObj.interest = this.$utils.convertNum(this.formObj.interest, 4)
    },
    lockedMoneyBlur: function() {
      this.formObj.lockedMoney = this.$utils.convertNum(this.formObj.lockedMoney, 4)
    },
    back: function() {
      this.$router.go(-1)
    },
    // 判斷是否管理員
    isSuper() {
      this.ifIsSuper = parseInt(this.$utils.getStorage('userProfile').isSuper)
    },
    // 提取弹窗开关
    closeTqTipPop: function() {
      this.tqTipPopVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        const financingCurrency = this.formObj.financingCurrency
        const interestCurrency = this.formObj.interestCurrency
        if (!financingCurrency) {
          // 请输入融资金额单位
          this.$message.error(this.$t('financingFundDetail.validFinancingCurrency'))
        } else if (!interestCurrency) {
          // 请输入利息单位
          this.$message.error(this.$t('financingFundDetail.validInterestCurrency'))
        } else if (valid) {
          const estimateStartDate = this.formObj.estimateStartDate
          const estimateEndDate = this.formObj.estimateEndDate
          const startDateTime = estimateStartDate.getTime()
          const endDateTime = estimateEndDate.getTime()
          if (startDateTime >= endDateTime) {
            // 预计开始日期不能大于预计到期日期
            // this.$message.error(this.$t('financingFundDetail.validTime'));
            this.$message.error(this.$t('error.forfait_estimateDay'))
          } else if (this.formObj.lockedMoney < 0 || this.formObj.lockedMoney > this.zmaFinancingManagement.availableBalance || !this.$utils.isMoney(this.formObj.lockedMoney)) {
            // 输入数字大于等于0小于当前可用资金锁定额且最多2位小数
            this.$message.error(this.$t('financingFundDetail.validPassTip1'))
          } else {
            this.openTqTipPop()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    validPass: function() {
      this.openTqTipPop()
      this.submitAdopt()
    },
    // 提取弹窗开关
    openTqTipPop: function() {
      // this.zmaFinancingInfo.lockedMone
      if (this.applicationStatus === 10) {
        this.finalMoney = math.number(math.subtract(math.bignumber(this.zmaFinancingManagement.availableBalance), math.bignumber(this.formObj.lockedMoney)))
      } else {
        this.finalMoney = math.number(math.subtract(math.bignumber(this.zmaFinancingManagement.availableBalance), math.bignumber(this.zmaFinancingInfo.lockedMoney)))
      }
      this.tqTipPopVisible = true
    },
    // 取字典表的value
    getdiscList() {
      this.axios.get('/static/sysDict/sysDictValue.json')
        .then(res => {
          // console.log('字典表',res);
          if (res.moneyType && res.moneyType.en) {
            this.moneyType = res.moneyType.en
          }
        })
        .catch(err => {
          this.$message.error(this.$t(`frontPage.${err.errorCode}`))
        })
    },
    /**
       * 资金锁定详情页面
       * @returns {Promise.<T>|Promise<never | T>}
       */
    getDetail: function() {
      const params = {
        flowNumber: this.flowNumber
      }
      var promise = this.axios.post('/capital/getCapitalLockDetail', params)
        .then(response => {
          if (response.status) {
            // console.log('资金锁定详情页面', response);
            const { riskManagementList, lockManagementList, cicFinancingCostDraftSnapshot, zmaFinancingInfo, cicFinancingApplyDraftSnapshot, zmaFinancingManagement, zmaFinancingOrderVo } = response.data
            this.$refs.baseDataFinance.handleInit(zmaFinancingOrderVo)
            if (riskManagementList && Array.isArray(riskManagementList)) {
              this.riskManagementList = riskManagementList
            }
            if (lockManagementList && Array.isArray(lockManagementList)) {
              this.lockManagementList = lockManagementList
            }
            if (cicFinancingCostDraftSnapshot && this.$utils.isObjFn(cicFinancingCostDraftSnapshot)) {
              this.cicFinancingCostDraftSnapshot = cicFinancingCostDraftSnapshot
            }
            if (zmaFinancingInfo && this.$utils.isObjFn(zmaFinancingInfo)) {
              this.zmaFinancingInfo = zmaFinancingInfo
              this.formObj.estimateStartDate = new Date(zmaFinancingInfo.estimateStartDate)
              this.formObj.estimateEndDate = new Date(zmaFinancingInfo.estimateEndDate)
              this.formObj.financingMoney = zmaFinancingInfo.financingMoney
              this.formObj.financingCurrency = zmaFinancingInfo.financingCurrency
              this.formObj.interestRate = zmaFinancingInfo.interestRate
              this.formObj.interest = zmaFinancingInfo.interest
              this.formObj.interestCurrency = zmaFinancingInfo.interestCurrency
              this.formObj.grantCurrency = zmaFinancingInfo.grantCurrency
              this.formObj.repaymentCurrency = zmaFinancingInfo.repaymentCurrency
              this.formObj.exchangeRate = zmaFinancingInfo.exchangeRate
              this.formObj.lockedMoney = zmaFinancingInfo.lockedMoney
              this.days = zmaFinancingInfo.days
            }
            if (cicFinancingApplyDraftSnapshot && this.$utils.isObjFn(cicFinancingApplyDraftSnapshot)) {
              this.cicFinancingApplyDraftSnapshot = cicFinancingApplyDraftSnapshot
            }
            if (zmaFinancingManagement && this.$utils.isObjFn(zmaFinancingManagement)) {
              this.zmaFinancingManagement = zmaFinancingManagement
            }

            this.applicationStatus = zmaFinancingManagement.applicationStatus
            this.formObj.lockedMoney = zmaFinancingInfo.lockedMoney
            this.formObj.financingCurrency = 'US$'
            this.formObj.grantCurrency = 'US$'
            this.formObj.interestCurrency = 'US$'
            this.formObj.repaymentCurrency = 'US$'
            this.interestRateBlur()
            this.financingMoneyBlur()
            this.interestBlur()
            this.lockedMoneyBlur()
            this.$nextTick(() => {
              if (this.applicationStatus !== 10 && zmaFinancingInfo) {
                this.$refs.zmaFinancingInfo.initData(response.data.zmaUpdateTimeLogs)
              }
            })
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    // 拒绝申请弹框关闭
    hide() {
      this.isShow = false
      this.isShowClose = false
      this.isShowPass = false
    },
    // 打回接口调用
    submitRepulse(value) {
      if (value === '') {
        this.repulseParameter.repulseReason = ''
        //   请输入原因
        this.$message.error(this.$t('financingFundDetail.verifyPopupPlaceholder'))
      } else {
        this.repulseParameter.repulseReason = value
        const applicationStatus = this.applicationStatus
        if (applicationStatus === 10) {
          // 资金锁定打回接口
          this.zmaRepulse()
        } else if (applicationStatus === 11) {
          // 一审打回接口
          this.firstRepulse()
        } else if (applicationStatus === 12) {
          // 二审打回
          this.secondRepulse()
        }
      }
    },
    // 通过接口调用
    submitAdopt() {
      const applicationStatus = this.applicationStatus
      if (applicationStatus === 10) {
        // 一审通过
        this.zmaAdopt()
      } else if (applicationStatus === 11) {
        // 一审通过
        this.firstAdopt()
      } else if (applicationStatus === 12) {
        // 二审通过
        this.secondAdopt()
      }
    },
    // 二审拒绝接口调用
    submitClose(value) {
      if (value === '') {
        this.closeParameter.closeReason = ''
        //   请输入原因
        this.$message.error(this.$t('financingFundDetail.verifyPopupPlaceholder'))
      } else {
        this.closeParameter.closeReason = value
        this.zmaClose()
      }
    },
    /**
       *资金锁定提交接口
       * @returns {Promise.<T>|Promise<never | T>}
       */
    zmaAdopt: function() {
      // console.log('estimateStartDate',typeof this.formObj.estimateStartDate,this.formObj.estimateStartDate.getTime())
      const params = {
        flowNumber: this.$route.query.in_id,
        estimateStartDate: this.formObj.estimateStartDate.toString(),
        estimateEndDate: this.formObj.estimateEndDate.toString(),
        financingMoney: this.formObj.financingMoney,
        financingCurrency: this.formObj.financingCurrency,
        interestRate: this.formObj.interestRate,
        interest: this.formObj.interest,
        interestCurrency: this.formObj.interestCurrency,
        grantCurrency: this.formObj.grantCurrency,
        repaymentCurrency: this.formObj.repaymentCurrency,
        exchangeRate: this.formObj.exchangeRate,
        lockedMoney: this.formObj.lockedMoney
      }

      var promise = this.axios.post('/capital/zmaAdopt', Object.assign({}, params))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingFundlist')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *资金锁定打回接口
       * @returns {Promise.<T>|Promise<never | T>}
       */
    zmaRepulse: function() {
      const params = {}
      var promise = this.axios.post('/capital/zmaRepulse', Object.assign(params, this.repulseParameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingFundlist')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *资金锁定-一审通过
       * @returns {Promise.<T>|Promise<never | T>}
       */
    firstAdopt: function() {
      const params = {}
      var promise = this.axios.post('/capital/firstAdopt', Object.assign(params, this.adoptParameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingFundlist')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *资金锁定-一审打回接口
       * @returns {Promise.<T>|Promise<never | T>}
       */
    firstRepulse: function() {
      const params = {}
      var promise = this.axios.post('/capital/firstRepulse', Object.assign(params, this.repulseParameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingFundlist')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *资金锁定-二审通过
       * @returns {Promise.<T>|Promise<never | T>}
       */
    secondAdopt: function() {
      const params = {}
      var promise = this.axios.post('/capital/secondAdopt', Object.assign(params, this.adoptParameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingFundlist')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *资金锁定-二审打回
       * @returns {Promise.<T>|Promise<never | T>}
       */
    secondRepulse: function() {
      const params = {}
      var promise = this.axios.post('/capital/secondRepulse', Object.assign(params, this.repulseParameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingFundlist')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *资金锁定-二审拒绝
       * @returns {Promise.<T>|Promise<never | T>}
       */
    zmaClose: function() {
      const params = {}
      var promise = this.axios.post('/capital/zmaClose', Object.assign(params, this.closeParameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingFundlist')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    linkToList: function(errorCode) {
      if (errorCode == 'loan_audit_5000005' || errorCode == 'loan_audit_50000031') {
        if (this.menuType && this.mean === 6) {
          this.$router.push('/allorders')
        } else {
          this.$router.push('/financingFundlist')
        }
      } else {
        this.$message.error(this.$t(`financingFundDetail.${errorCode}`))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep{
    .el-tabs--top.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2){
      padding:0 78px;
    }
  }
  ::v-deep {
    .el-input-group--append.theme-default .el-input__inner, .el-input-group__prepend{
      background: none;
      border-right: 0;
    }
  }

  .selectClass ::v-deep{
    .el-form-item.is-success .el-input__inner{
      border: 0;
    }

  }
  .selectClass ::v-deep{
    border-right:0 ;
    input{
      border: 0;
    }
  }
  ::v-deep{
    .el-form-item.is-success .el-input-group__append .el-input__inner, .el-form-item.is-success .el-input-group__prepend .el-input__inner{
      border: 0;
    }
  }

  ::v-deep .el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #E9EBF0;
  }
  .el-form-item.is-error ::v-deep{
    .el-input-group--append.theme-default .el-input__inner{
      /*border:1px solid #F56C6C;*/
    }
    .el-input-group--append,.el-input-group--prepend{
      border:1px solid #F56C6C;
      border-radius: 4px;
    }
  }
  .diver{
    border-bottom: 1px solid #EAEAEA;
  }
  .whiteFixed{
    position: fixed;
    border-top:1px solid #EAEAEA;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100px;
    line-height: 100px;
    background: #ffffff;
    z-index: 99;
  }
  .jsbTb {
    width: 570px;
    border-collapse: collapse;
    td {
      font-size: 14px;
      border: 1px solid #E9EBF0;
      padding: 0 10px;
      height: 36px;
      &.td1 {
        width: 180px;
        background: #F8FAFD;
      }
      &.td2 {
        width: 350px;
      }
    }
  }

  .jsbH4 {
    margin-bottom: 10px;
    text-align: center;
    background: #D9E2FE;
    border-radius: 2px;
    font-size: 14px;
    color: #7996F5;
    height: 34px;
    line-height: 34px;
    overflow: hidden;
    vertical-align: middle;
    i {
      display: inline-block;
      background: url(../../assets/images/common/icoHzD.png) no-repeat center;
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }

  .mrfhTb {
    width: 570px;
    border-collapse: collapse;
    tr.tr1 {
      td {
        background: #F8FAFD;
      }
    }
    td {
      font-size: 14px;
      border: 1px solid #E9EBF0;
      padding: 0 10px;
      height: 36px;
      text-align: center;

      &.td1 {
        width: 122px;
      }

      &.td2 {
        width: 230px;
      }

      &.td3 {
        width: 160px;
      }
    }
  }
  .w520{
    width: 520px;
  }

  .bonusDetail{
    .box-item{
      box-shadow: none;
      padding: 0;
    }
  }
</style>

